const ROLE_LABELS = {
  admin: '🛡️ Admin',
  trainer: '👨‍🏫 Trener',
  player: '🏀 Gracz',
};

export const normalizeRoles = (userData = {}) => {
  const safeUserData = userData || {};

  if (Array.isArray(safeUserData.roles) && safeUserData.roles.length > 0) {
    return [...new Set(safeUserData.roles.map((role) => String(role).toLowerCase()))];
  }

  if (safeUserData.role) {
    return [String(safeUserData.role).toLowerCase()];
  }

  return ['player'];
};

export const getActiveRole = (userData) => {
  const roles = normalizeRoles(userData);
  const requestedRole = String(userData?.activeRole || '').toLowerCase();
  if (requestedRole && roles.includes(requestedRole)) {
    return requestedRole;
  }

  if (roles.includes('admin')) return 'admin';
  if (roles.includes('trainer')) return 'trainer';
  return 'player';
};

export const hasRole = (userData, role) => getActiveRole(userData) === role;

export const hasAnyRole = (userData, roles = []) => {
  const activeRole = getActiveRole(userData);
  return roles.some((role) => activeRole === role);
};

export const rolesToPrimaryRole = (userData) => {
  const roles = normalizeRoles(userData);
  if (roles.includes('admin')) return 'admin';
  if (roles.includes('trainer')) return 'trainer';
  return 'player';
};

export const getRoleLabels = (userData) =>
  normalizeRoles(userData).map((role) => ROLE_LABELS[role] || role);

export const getRoleLabel = (role) => ROLE_LABELS[role] || role;

export const upsertRole = (roles = [], roleToAdd) => {
  const normalized = [...new Set(roles.map((role) => String(role).toLowerCase()))];
  const normalizedRole = String(roleToAdd).toLowerCase();
  if (!normalized.includes(normalizedRole)) {
    normalized.push(normalizedRole);
  }
  return normalized;
};

export const removeRole = (roles = [], roleToRemove) => {
  const normalized = [...new Set(roles.map((role) => String(role).toLowerCase()))];
  const normalizedRole = String(roleToRemove).toLowerCase();
  const next = normalized.filter((role) => role !== normalizedRole);
  return next.length > 0 ? next : ['player'];
};